<!-- Request Compliance Framework Popup -->
<div class="request-compliance-container">
  <!-- Header -->
  <div class="popup-header">
    <div class="header-content">
      <h3 class="popup-title">Request Compliance Framework</h3>
      <p class="popup-subtitle">
        Can't find the compliance framework you need? Let us know and we'll add it to the system.
      </p>
    </div>
    <button
      class="btn-close"
      type="button"
      [attr.aria-label]="'Close'"
      (click)="onClose()"
    >
      <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
    </button>
  </div>

  <!-- Form Content -->
  <div class="popup-content">
    <form
      [formGroup]="requestForm"
      (ngSubmit)="onSubmit()"
    >
      <!-- Compliance Framework Name -->
      <div class="mb-3">
        <label
          for="complianceFramework"
          class="form-label fw-semibold"
        >
          Compliance Framework Name
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          id="complianceFramework"
          formControlName="complianceFramework"
          class="form-control"
          [class.is-invalid]="hasError('complianceFramework')"
          placeholder="e.g., GDPR, ISO 27001, CMMC Level 2"
        />
        @if (hasError('complianceFramework')) {
          <div class="invalid-feedback d-block">
            {{ getErrorMessage('complianceFramework') }}
          </div>
        }
      </div>

      <!-- Additional Details -->
      <div class="mb-4">
        <label
          for="additionalDetails"
          class="form-label fw-semibold"
        >
          Additional Details or Requirements
          <span class="text-muted small">(Optional)</span>
        </label>
        <textarea
          id="additionalDetails"
          formControlName="additionalDetails"
          class="form-control"
          rows="4"
          placeholder="Please provide any specific requirements, sections, or controls you need included in this compliance report..."
        ></textarea>
        <div class="form-text">
          Help us understand your specific compliance reporting needs
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          kendoButton
          class="cyflare-btn-secondary"
          (click)="onClose()"
          [disabled]="isSubmitting"
        >
          Cancel
        </button>
        <button
          type="submit"
          kendoButton
          class="cyflare-btn-primary"
          [disabled]="requestForm.invalid || isSubmitting"
        >
          @if (isSubmitting) {
            <span class="spinner-border spinner-border-sm me-2"></span>
            Submitting...
          } @else {
            Submit Request
          }
        </button>
      </div>
    </form>
  </div>
</div>
